import { SystemField } from "./system-field";

export class UserRole extends SystemField {
     
     name?:string;
     description?:string;
     parent_role_id?:string;
}
